import React from 'react';

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular' | 'rounded';
  width?: string | number;
  height?: string | number;
  animation?: 'pulse' | 'wave' | 'none';
}

const Skeleton: React.FC<SkeletonProps> = ({
  className = '',
  variant = 'rectangular',
  width,
  height,
  animation = 'pulse',
}) => {
  const baseClasses = 'bg-gray-200 dark:bg-gray-700';
  
  const variantClasses = {
    text: 'h-4 rounded',
    circular: 'rounded-full',
    rectangular: 'rounded-none',
    rounded: 'rounded-lg',
  };

  const animationClasses = {
    pulse: 'animate-pulse',
    wave: 'animate-shimmer',
    none: '',
  };

  const style: React.CSSProperties = {};
  if (width) style.width = typeof width === 'number' ? `${width}px` : width;
  if (height) style.height = typeof height === 'number' ? `${height}px` : height;

  return (
    <div
      className={`${baseClasses} ${variantClasses[variant]} ${animationClasses[animation]} ${className}`}
      style={style}
      aria-label="Loading..."
      role="status"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

// 预设骨架屏组件
export const ImageSkeleton: React.FC<{ className?: string; aspectRatio?: string }> = ({
  className = '',
  aspectRatio = '16/9',
}) => (
  <div className={`relative overflow-hidden ${className}`} style={{ aspectRatio }}>
    <Skeleton variant="rounded" animation="pulse" className="absolute inset-0" />
  </div>
);

export const TextSkeleton: React.FC<{ lines?: number; className?: string }> = ({
  lines = 3,
  className = '',
}) => (
  <div className={`space-y-2 ${className}`}>
    {Array.from({ length: lines }).map((_, index) => (
      <Skeleton
        key={index}
        variant="text"
        width={index === lines - 1 ? '80%' : '100%'}
        animation="pulse"
      />
    ))}
  </div>
);

export const CardSkeleton: React.FC = () => (
  <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
    <Skeleton variant="circular" width={40} height={40} className="mb-3" />
    <Skeleton variant="text" width="60%" height={20} className="mb-2" />
    <Skeleton variant="text" width="100%" height={16} className="mb-1" />
    <Skeleton variant="text" width="90%" height={16} />
  </div>
);

export default Skeleton;

